/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobBatchResponse {
    getFixupPrototypeFunction() { return TemplateJobBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobBatchResponse>): TemplateJobBatchResponse {
        let obj = Object.assign(new TemplateJobBatchResponse(), model);
        TemplateJobBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobBatchResponse>): TemplateJobBatchResponse {
        if (!model) return null;
        return TemplateJobBatchResponse.newInstance(<TemplateJobBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobBatchResponse) {
        if (!obj) return;

        models.TemplateJobBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobBatchResponse): boolean {
        Object.setPrototypeOf(obj, TemplateJobBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TemplateJobItemResponse.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TemplateJobItemResponse; };

}
